import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-24" data-id="element-15" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-5xl" data-id="element-16" data-mp="avld0krwb3nu">
        <h2 className="text-center font-serif text-[2.5rem] leading-[1.06] text-sage-800 sm:text-5xl lg:text-[3.5rem]" data-id="element-17" data-mp="aujwi0s41oyq">
          Y sólo por hoy los{' '}
          <span className="font-bold text-terracotta-500" data-id="element-18" data-mp="1tvj98ajjsmw">BONUS GRATIS</span>
        </h2>

        <div className="mt-16 space-y-10 lg:space-y-14" data-id="element-19" data-mp="5vqmiic18g3b">
          {bonuses.map((bonus, index) => {
          const imageFirst = index % 2 === 0;
          if (bonus.featured) {
            return <article key={bonus.title} className="grid items-center gap-6 rounded-4xl border-2 border-gold-400/70 bg-bone p-6 shadow-[0_28px_60px_-38px_rgba(56,52,44,0.65)] sm:p-9 lg:grid-cols-2 lg:gap-14 lg:p-12" data-id="element-20" data-mp="3t0om0gkzfztj">
                  <div className={`rounded-3xl bg-cream p-6 sm:p-10 ${imageFirst ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-21" data-mp="1r9uy960uccag">
                    <img src={bonus.image} alt={`${bonus.title} — incluido en tu compra`} className="mx-auto w-full max-w-[300px] drop-shadow-[0_26px_40px_rgba(56,52,44,0.24)] sm:max-w-[330px]" data-id="element-22" data-mp="3idel6385ly3t" />
                  </div>

                  <div className={imageFirst ? 'lg:order-2' : 'lg:order-1'} data-id="element-23" data-mp="3r68f96s9f21q">
                    <div className="flex flex-wrap items-center gap-3" data-id="element-24" data-mp="3n67ocmnz4yds">
                      <span className="inline-flex items-center gap-1.5 rounded-full bg-terracotta-500 px-3.5 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.16em] text-cream" data-id="element-25" data-mp="2zfaldze5pbeo">
                        <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-26" data-mp="38g8u2uzji73l" />
                        Bonus destacado
                      </span>
                      <span className="text-[12px] font-medium text-ink-light line-through" data-id="element-27" data-mp="33ge3ytnl9ljl">
                        {bonus.value}
                      </span>
                    </div>
                    <h3 className="mt-4 font-serif text-[2.1rem] leading-tight text-sage-800 sm:text-[2.6rem]" data-id="element-28" data-mp="irq4gxaxp8ef">
                      {bonus.title}
                    </h3>
                    <p className="mt-4 text-[16px] leading-relaxed text-ink-soft sm:text-[17px]" data-id="element-29" data-mp="3hhr79jvlktzk">
                      {bonus.body}
                    </p>
                    <p className="mt-5 inline-block rounded-full bg-sage-100 px-4 py-1.5 text-[11.5px] font-semibold uppercase tracking-[0.12em] text-sage-700" data-id="element-30" data-mp="3lke4k0b1f745">
                      Incluido en tu compra
                    </p>
                  </div>
                </article>;
          }
          return <article key={bonus.title} className="grid items-center gap-6 rounded-4xl border border-gold-200/50 bg-bone p-6 sm:p-8 lg:grid-cols-2 lg:gap-12 lg:p-10" data-id="element-31" data-mp="2xujs3jumrkkf" data-mpi={index}>
                <div className={`rounded-3xl bg-cream p-6 sm:p-9 ${imageFirst ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-32" data-mp="37k3bqrq63igc">
                  <img src={bonus.image} alt={`${bonus.title} — recurso incluido`} className="mx-auto w-full max-w-[260px] drop-shadow-[0_22px_36px_rgba(56,52,44,0.2)]" data-id="element-33" data-mp="2a3eg5frt9cfe" />
                </div>

                <div className={imageFirst ? 'lg:order-2' : 'lg:order-1'} data-id="element-34" data-mp="27iyj3bmuuyox">
                  <div className="flex flex-wrap items-center gap-3" data-id="element-35" data-mp="22l6htr0bm082">
                    <span className="rounded-full bg-sage-700 px-3.5 py-1 text-[10.5px] font-semibold uppercase tracking-[0.16em] text-cream" data-id="element-36" data-mp="22iu45q1lic0t">
                      Bonus {bonus.index}
                    </span>
                    <span className="text-[12px] font-medium text-ink-light line-through" data-id="element-37" data-mp="1ol5em4wl2gpf">
                      {bonus.value}
                    </span>
                  </div>
                  <h3 className="mt-4 font-serif text-[1.7rem] leading-tight text-sage-800 sm:text-[2.1rem]" data-id="element-38" data-mp="1jscanj8xvcee">
                    {bonus.title}
                  </h3>
                  <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-39" data-mp="19xap0xdvgsgk">
                    {bonus.body}
                  </p>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}